import {View} from "@lernetz/ts-lib";
import {Router} from "@lernetz/ui-components/src/router/Router";
import {languageService} from "../../../services/lang";
import template from "./route-link.component.html";


export class RouteLink extends View {
    constructor(router: Router) {
        super({ template, data: new RouteLinkController(router)})
    }
}

class RouteLinkController {
    path: any;
    routeName: string;
    routeParams: any;
    isActive: boolean;
    currentLang: any;
    constructor(private router) {
        this.currentLang = languageService.currentLang
    }

    goTo(event) {
        if (this.path) {
            event.preventDefault();
            this.router.toPath(this.path);
        }
        if (this.routeName) {
            event.preventDefault();
            this.router.toRoute(this.routeName, {lang: this.currentLang, ...this.routeParams });
        }
    }

    init() {
        if (this.path) {
            this.isActive = window.location.pathname === this.path;
        }
        if (this.routeName) {
            if (this.router.current.route) {
                this.isActive = this.router.current.route.name === this.routeName;
            } else {
                let found = this.router.routes.find( r => r.name == this.routeName );
                this.isActive = found.pathOf( this.routeParams ) === window.location.pathname;


            }
        }
    }
}
